import React from 'react';
import { SolidUser } from '..';

export interface UnidentifiedAvatarProps {
  className?: string;
  sizeStyles?: string;
}

export const UnidentifiedAvatar = ({
  className,
  sizeStyles,
  ...rest
}: UnidentifiedAvatarProps) => {
  return (
    <SolidUser className={`${sizeStyles} ${className}`} {...rest}>
      <title>Unidentifed User</title>
    </SolidUser>
  );
};
